<script setup lang="ts">
import Carousel from './Carousel.vue';
import PeopleCard from './PeopleCard.vue';
</script>

<template>
  <div class="h-383 w-full bg-[url(@/home/assets/home/banner3.png)] bg-cover pt-107">
    <div class="container flex">
      <Carousel class="flex-shrink-0" />
      <PeopleCard class="ml-32 flex-shrink-0" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
